export interface ChargeWaiverSearchCriteria {
    cntrList?: string[] | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    consortiumCode?: string | null,
    waiverReason?: string | null,
    etd?: Date | null,
    shippingBill?: string | null

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_CHARGE_WAIVER_SEARCH_CRITERIA: ChargeWaiverSearchCriteria = {

    cntrList: [],
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    waiverReason: null,
    etd: null,
    shippingBill: null,
}